<template lang="html">
  <div class="list-product-related">
    <div ref="el" class="wrap-list-product-related" @mousedown="onMouseDown" @mouseup="onMouseUp">
      <div class="content-list-product-related">
        <div v-for="(item, i) in items" :key="i" class="item-product-related" @click.stop="showDetail(item)">
          <div class="flex-image">
            <div class="d-flex mr-2">
              <img :src="item.photo_md" :alt="item.name" class="image-56 br-8" @error="imageLoadError">
            </div>
            <div class="flex-image-content">
              <div class="flex-image-content-text font-12 font-weight-400 mb-2">
                {{ item.name }}
              </div>
              <div class="flex-image-content-text font-12 font-weight-600">
                <span v-if="$usePosPrice()" v-mask-money="item.sell_price_pos" />
                <span v-else v-mask-money="item.sell_price" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SlideProduct',
  props: {
    items: {
      required: true,
      type: Array
    },
    clickDetail: {
      required: true,
      type: Function
    }
  },
  data() {
    return {
      cursorPos: [0, 0],
      el: null
    }
  },
  mounted() {
    window.addEventListener('mouseup', this.onMouseUp)
  },
  destroyed() {
    window.removeEventListener('mouseup', this.onMouseUp)
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    onMouseDown(ev) {
      this.cursorPos = [ev.pageX, ev.pageY]
      window.addEventListener('mousemove', this.onMouseHold)
    },
    onMouseUp(ev) {
      window.removeEventListener('mousemove', this.onMouseHold)
    },
    onMouseHold(ev) {
      ev.preventDefault()
      requestAnimationFrame(() => {
        const delta = [
          ev.pageX - this.cursorPos[0],
          ev.pageY - this.cursorPos[1]
        ]
        this.cursorPos = [ev.pageX, ev.pageY]
        if (!this.$refs.el) return
        this.$refs.el.scrollBy({
          left: -delta[0],
          top: -delta[1]
        })
      })
    },
    async showDetail(item) {
      await this.clickDetail(item)
    }
  }
}
</script>
